import React from 'react';
import { Chip } from '@mui/material';

const statusColorMap = {
  active: 'success',
  inactive: 'error',
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  verified: 'success',
  completed: 'success',
  cancelled: 'error',
  confirmed: 'info',
  shipped: 'info',
  delivered: 'success',
  live: 'error',
  ended: 'default',
  scheduled: 'warning',
  published: 'success',
  draft: 'default',
  paid: 'success',
  unpaid: 'warning',
  refunded: 'info',
  failed: 'error',
  online: 'success',
  offline: 'default',
  busy: 'warning',
};

const StatusChip = ({ status, label }) => {
  const color = statusColorMap[status?.toLowerCase()] || 'default';

  return (
    <Chip
      label={label || (status ? status.charAt(0).toUpperCase() + status.slice(1) : '-')}
      color={color === 'default' ? undefined : color}
      variant="filled"
      size="small"
      sx={{
        fontWeight: 600,
        textTransform: 'capitalize',
        ...(color === 'default' && { backgroundColor: '#E0E0E0', color: '#616161' }),
      }}
    />
  );
};

export default StatusChip;
